"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateTwentyOne = simulateTwentyOne;
const zod_1 = require("zod");
const logic_1 = require("./logic");
const verification_dealer_1 = require("./logic/dealer/verification-dealer");
function simulateTwentyOne(attestation, moves, logicVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const dealer = new verification_dealer_1.VerificationDealer(attestation);
        const game = logic_1.TwentyOneGameBuilder.newGame(dealer, logicVersion);
        yield game.startGame(false);
        for (const move of moves) {
            const command = logic_1.CommandListSerializer.moveToCommand(move);
            game.executeCommand(command, true);
            yield game.waitForAllTasksToBeCompleted();
        }
        if (dealer.hasForbiddenDisclosure()) {
            return {
                simStatus: "error",
                error: "Forbidden disclosure",
            };
        }
        const scoreData = game.generateScoreData();
        return {
            simStatus: "success",
            score: scoreData.score,
            analyticsData: zod_1.z
                .record(zod_1.z.string(), zod_1.z.union([zod_1.z.string(), zod_1.z.number()]))
                .parse(game.getAnalyicsData()),
        };
    });
}
